import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { rgba } from 'polished';
import styled, { createGlobalStyle } from 'styled-components';
const GlobalStyles = createGlobalStyle `
  :root {
    --bannerHeight: 50px;
  }
`;
const GlobalStylesNoBanner = createGlobalStyle `
  :root {
    --bannerHeight: 0px;
  }
`;
const Container = styled.section `
  ${transition('max-height')};

  --accentColor: ${brand.primary.orange};
  --bgColor: ${brand.primary.blue};
  --fgColor: ${brand.white};

  background: var(--bgColor);
  color: var(--fgColor);
  font-size: ${fluid(16, 18)};
  line-height: 1em;
  max-height: 0;
  overflow: hidden;

  &[data-is-showing='true'] {
    max-height: var(--bannerHeight);
  }
`;
const Inner = styled.div `
  ${siteWide}

  display: grid;
  align-items: center;
  column-gap: 12px;
  grid-template-columns: auto auto 1fr auto;
  height: var(--bannerHeight);
`;
const Pagination = styled.div `
  display: flex;
  align-items: center;
  column-gap: 10px;
  ${fonts.apparat.semiBold}

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const PaginationButton = styled.button `
  ${ButtonReset}

  color: currentColor;
  opacity: 1;
  width: 6px;

  &:disabled {
    opacity: 0.5;
  }
`;
const Counter = styled.span `
  font-variant-numeric: tabular-nums;
`;
const Title = styled.span `
  display: flex;
  align-items: center;
  ${fonts.apparat.semiBold}

  svg {
    margin-right: 8px;
    transform: translateY(-2px);
    width: 10px;
  }
`;
const CarouselWrapper = styled.div `
  min-width: 0;
  overflow: hidden;
`;
const Close = styled.button `
  ${ButtonReset}

  ${transition('background-color, border-color, color')}

  display: grid;
  background: ${rgba(brand.white, 0)};
  border: 1px solid currentColor;
  border-radius: 50%;
  color: currentColor;
  height: 30px;
  place-content: center;
  place-items: center;
  width: 30px;

  svg {
    display: block;
    height: 10px;
    width: 10px;
  }

  &:focus,
  &:hover {
    background: ${rgba(brand.white, 1)};
    border-color: var(--fgColor);
    color: var(--bgColor);
  }

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const Item = styled.li `
  display: flex;
  flex: 0 0 auto;
  max-width: 100%;
  overflow: hidden;
  padding-right: ${fluid(32, 72)};
  white-space: nowrap;
`;
const ItemTitle = styled.span `
  ${fonts.apparat.light}
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const ItemTitleShort = styled.span `
  ${fonts.apparat.semiBold}
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const ItemLink = styled.a `
  color: currentColor;
  ${fonts.apparat.semiBold}
  padding-left: 8px;
  text-decoration: none;
`;
const ItemLinkText = styled.span `
  ${transition('border-color')}

  border-bottom: 1px solid ${rgba(brand.white, 0)};
  margin-right: 8px;

  ${ItemLink}:focus &,
  ${ItemLink}:hover & {
    border-color: ${rgba(brand.white, 1)};
  }

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const ItemLinkIcon = styled.span `
  ${transition('transform')}

  color: var(--accentColor);
  width: 13px;

  ${ItemLink}:focus &,
  ${ItemLink}:hover & {
    transform: translateX(8px);
  }
`;
const NewsFlashBannerStyles = {
    CarouselWrapper,
    Close,
    Container,
    Counter,
    Inner,
    Item,
    ItemLink,
    ItemLinkIcon,
    ItemLinkText,
    ItemTitle,
    ItemTitleShort,
    Pagination,
    PaginationButton,
    Title,
    GlobalStyles,
    GlobalStylesNoBanner,
};
export default NewsFlashBannerStyles;
